// extracted by mini-css-extract-plugin
export default {"title":"PatientAssignPreconfigsDialog_title__rKNK0","content":"PatientAssignPreconfigsDialog_content__C3CzF"};